import AbstractView from 'abstracts/AbstractView';
import Main from "controllers/Main";
import Screen from "controllers/Screen";
import Scroll from "controllers/Scroll";
import TransitionController from "../../../../assets/src/js/app/controllers/TransitionController";

export default new class Header extends AbstractView {

	constructor() {
		super();
		this.scrollLimit = 100;
		this.isShown = false;
		this.isSticked = false;
	}


	initDOM() {
		this.$header = $("#header");
		this.$logo = $("#main-logo");
	}


	initEl() {
		this.tw.logoTween = gsap.to(this.$logo, {
			duration: 0.5,
			backgroundPositionY: -300,
			ease: "steps(12)",
			paused: true
		}).progress(1);
	}

	bindEvents() {
		Main.on(Main.E.RAF, this.raf, this);
		Screen.on(Screen.E.RESIZE, this.resize, this);

		this.enterLogoHandler = this.enterLogo.bind(this);
		this.leaveLogoHandler = this.leaveLogo.bind(this);
		
		this.$logo[0].addEventListener("mouseenter", this.enterLogoHandler, {passive: true});
		this.$logo[0].addEventListener("touchstart", this.enterLogoHandler, {passive: true});
		this.$logo[0].addEventListener("focus", this.enterLogoHandler, {passive: true});
		
		this.$logo[0].addEventListener("mouseleave", this.leaveLogoHandler, {passive: true});
		this.$logo[0].addEventListener("touchend", this.leaveLogoHandler, {passive: true});
		this.$logo[0].addEventListener("blur", this.leaveLogoHandler, {passive: true});

		this.onDownHandler = this.onDown.bind(this);
		this.onUpHandler = this.onUp.bind(this);
		Observer.create({
			target: window,         // can be any element (selector text is fine)
			type: "scroll",    // comma-delimited list of what to listen for ("wheel,touch,scroll,pointer")
			onUp: this.onUpHandler,
			onDown: this.onDownHandler,
		});

		this.mobileClickHandler = this.mobileClick.bind(this);
		this.$header.on('click', '.mobile-toggle', this.mobileClickHandler);

		TransitionController.on(TransitionController.E.INIT_BLOCKS, this.onInitBlocks, this);
	}

	enterLogo() {
		if (!this.isSticked) {
			return;
		}
		this.tw.logoTween.timeScale(1).play();
	}

	leaveLogo() {
		if (!this.isSticked) {
			return;
		}
		this.tw.logoTween.timeScale(1.3).reverse();
	}

	raf() {
		if (Scroll.yI > this.scrollLimit && this.isSticked === false) {
			this.isSticked = true;
			this.$header.addClass('sticked');
			this.tw.logoTween.timeScale(1.3).reverse();
		} else if (Scroll.yI <= this.scrollLimit && this.isSticked === true) {
			this.isSticked = false;
			this.$header.removeClass('sticked');
			this.tw.logoTween.timeScale(1.3).play();
		}
	}

	onDown() {
		if (this.isShown === true) {
			this.isShown = false;
			this.$header.removeClass('visible');
		}
	}

	onUp() {
		if (this.isShown === false) {
			this.isShown = true;
			this.$header.addClass('visible');
		}
	}

	resize() {
		if (Screen.IS_DESKTOP && !Main.$body.hasClass('single-project')) {
			this.scrollLimit = Screen.wH * 1.3;
		} else {
			this.scrollLimit = 100;
		}
	}

	mobileClick() {
		this.$header.toggleClass('mobile-menu-open');
	}

	onInitBlocks() {
		this.$header.removeClass('mobile-menu-open');
		this.resize();
	}


}
